"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containerBackgroundColor = exports.Wrapper = exports.SubHeading = exports.HeadingsContainer = exports.Heading = exports.ComponentContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DynamicHeading = require("../../../components/DynamicHeading");
var _LexusTypography = require("../../../components/LexusTypography");
var _breakpoints = _interopRequireDefault(require("../../../components/breakpoints"));
var _utilities = require("../../../utilities");
const containerBackgroundColor = function ($theme, $backgroundColor, $backgroundOpacity) {
  if ($backgroundOpacity && $backgroundColor) {
    return (0, _utilities.colorToAlphaHex)($backgroundColor, $backgroundOpacity);
  }
  if ($backgroundColor) {
    return (0, _utilities.colorToAlphaHex)($backgroundColor, 1);
  }
  if ($theme === "black") {
    return "rgba(0,0,0,1)";
  }
  if ($theme === "white") {
    return "rgba(255,255,255,0)";
  }
  return undefined;
};
exports.containerBackgroundColor = containerBackgroundColor;
const ComponentContainer = exports.ComponentContainer = _styledComponents.default.div`

	&& {
	background-color: ${function (_ref) {
  let {
    $theme = "",
    $backgroundColor = "",
    $backgroundOpacity = 1
  } = _ref;
  return containerBackgroundColor($theme, $backgroundColor, $backgroundOpacity);
}};
  }

	position: relative;
	
	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: ${function (_ref2) {
  let {
    $backgroundOpacity
  } = _ref2;
  return $backgroundOpacity;
}};
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		z-index: 0;

		background-color: ${function (_ref3) {
  let {
    $theme = "",
    $backgroundColor = "",
    $backgroundOpacity = 1
  } = _ref3;
  return containerBackgroundColor($theme, $backgroundColor, $backgroundOpacity);
}};
		
		${(0, _breakpoints.default)("desktop", "up")} {
			background-image: ${function (_ref4) {
  var _$backgroundImage$des;
  let {
    $backgroundImage
  } = _ref4;
  return $backgroundImage !== null && $backgroundImage !== void 0 && (_$backgroundImage$des = $backgroundImage.desktop) !== null && _$backgroundImage$des !== void 0 && _$backgroundImage$des.src ? `url(${$backgroundImage.desktop.src})` : "none";
}};
		}
		${(0, _breakpoints.default)("tablet", "down")} {
			background-image: ${function (_ref5) {
  var _$backgroundImage$tab, _$backgroundImage$des2;
  let {
    $backgroundImage
  } = _ref5;
  return $backgroundImage !== null && $backgroundImage !== void 0 && (_$backgroundImage$tab = $backgroundImage.tablet) !== null && _$backgroundImage$tab !== void 0 && _$backgroundImage$tab.src ? `url(${$backgroundImage.tablet.src})` : $backgroundImage !== null && $backgroundImage !== void 0 && (_$backgroundImage$des2 = $backgroundImage.desktop) !== null && _$backgroundImage$des2 !== void 0 && _$backgroundImage$des2.src ? `url(${$backgroundImage.desktop.src})` : "none";
}};
		}
		${(0, _breakpoints.default)("mobile", "down")} {
			background-image: ${function (_ref6) {
  var _$backgroundImage$mob, _$backgroundImage$tab2;
  let {
    $backgroundImage
  } = _ref6;
  return $backgroundImage !== null && $backgroundImage !== void 0 && (_$backgroundImage$mob = $backgroundImage.mobile) !== null && _$backgroundImage$mob !== void 0 && _$backgroundImage$mob.src ? `url(${$backgroundImage.mobile.src})` : $backgroundImage !== null && $backgroundImage !== void 0 && (_$backgroundImage$tab2 = $backgroundImage.tablet) !== null && _$backgroundImage$tab2 !== void 0 && _$backgroundImage$tab2.src ? `url(${$backgroundImage.tablet.src})` : "none";
}};
		}
	}
`;
const HeadingsContainer = exports.HeadingsContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  text-align: center;
	margin-bottom: 40px;
`;
const Heading = exports.Heading = (0, _styledComponents.default)(_DynamicHeading.DynamicHeading).attrs({
  defaultLevel: 3
})`
  ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "heading24"
})}

	margin: 0;

	${function (_ref7) {
  let {
    $headingColor
  } = _ref7;
  return $headingColor ? `color: ${$headingColor};` : undefined;
}}
`;
const SubHeading = exports.SubHeading = _styledComponents.default.div`
  ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "subheading18"
})}

	margin-top: 25px;
	
	${function (_ref8) {
  let {
    $subHeadingColor
  } = _ref8;
  return $subHeadingColor ? `color: ${$subHeadingColor};` : undefined;
}}
`;
const Wrapper = exports.Wrapper = _styledComponents.default.div`
	position: relative;
`;